import {ResolvingLitElement} from "../../lib/ResolvingLitElement.js";
import {html} from "lit";
import {TimeTool} from "../../lib/TimeTool.js";
import {mdiCurrencyEur, mdiCurrencyEurOff} from "@mdi/js";

export class TimesheetEntryTableWidget extends ResolvingLitElement {

    static properties = {
        customerId: {type: String},
        customerName: {type: String}
    }

    /**
     * @private {ReactiveArray<TimesheetEntry>}
     */
    _entries;

    constructor() {
        super();
        this.customerId = "";
    }

    render() {
        if (!this.customerId) {
            return "";
        }
        return html`<div class="card timesheet-entry-table">
                <header>
                    <h4>${this.customerName}</h4>
                </header>
                <table class="striped time-entries">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Duration</th>
                            <th>Task ID</th>
                            <th>Task</th>
                        </tr>
                    </thead>
                    <tbody>
                    ${this._filteredEntries().map( (item, key) => {
                        return html`<tr>
                            <td>${this._formatDates(item.start, item.end)}</td>
                            <td>${TimeTool.formatDurationFromSeconds(item.duration, false)}</td>
                            <td><a href="${item.task.url}" target="_blank">${item.task.customId ? item.task.customId : item.task.id}</a></td>
                            <td>${item.task.name}<br>
                                <svg style="width:22px;height:22px;display:inline-block;" viewBox="0 0 22 22"><path fill="${item.billable ? '#14854f' : '#bbb'}" d="${item.billable ? mdiCurrencyEur : mdiCurrencyEurOff}" /></svg> ${this._formatTags(item.tags)}
                                ${item.description ? html`<span class="entry-description">${item.description}</span>` : ''}
                            </td>
                        </tr>`
        })}
                    </tbody>
                    <tfoot>
                        <tr>
                            <th></th>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    </tfoot>
                </table>
            </div>`;
    }

    get customerName() {
        if (!this.customerId) {
            return "";
        }
        for(let entry of this._entries.items()) {
            if (entry.task && entry.task.customer && entry.task.customer.id === this.customerId) {

                return entry.task.customer.name;
            }
        }
        return "";
    }

    /**
     * @return {TimesheetEntry[]}
     * @private
     */
    _filteredEntries() {
        return this._entries.filter(/** @param {TimesheetEntry} entry **/ (entry) => {
            return entry.task && entry.task.customer && entry.task.customer.id === this.customerId;
        });
    }

    connectedCallback() {
        super.connectedCallback();
        this._entries = this._get('timesheet-entries');
    }

    updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has('customerId')) {

            //this.requestUpdate();
        }
    }

    createRenderRoot() {
        return this;
    }

    /**
     * @param {Date} start
     * @param {Date} end
     * @return {string}
     * @private
     */
    _formatDates(start, end) {
        let str = start.toLocaleDateString() + ' ';
        str += ('0' + start.getHours()).slice(-2) + ':' + ('0' + start.getMinutes()).slice(-2);
        str += '-';
        str += ('0' + end.getHours()).slice(-2) + ':' + ('0' + end.getMinutes()).slice(-2);
        return str;
    }

    /**
     * @param {Tag[]} tags
     * @return {string[]}
     * @private
     */
    _formatTags(tags) {
        let spans = [];
        for (let tag of tags) {
            let bgColor = tag.tag_bg;
            let fgColor = this._isLightColor(bgColor) ? 'black' : 'white';
            spans.push(html`<span class="tag is-small time-entry-tag" style="color:${fgColor}; background-color: ${tag.tag_bg}">${tag.name}</span>`);
        }
        return spans
    }

    /**
     * @param {string} color
     * @return {boolean}
     * @private
     */
    _isLightColor(color) {
        if (color.length !== 7 && color.length !== 9 ) {
            return false;
        }

        const rgb = [
            parseInt(color.substring(1, 3), 16),
            parseInt(color.substring(3, 5), 16),
            parseInt(color.substring(5, 7), 16),
        ];

        const luminance =
            (0.2126 * rgb[0]) / 255 +
            (0.7152 * rgb[1]) / 255 +
            (0.0722 * rgb[2]) / 255;
        return luminance > 0.5;

    }

}

customElements.define('x-timesheet-entry-widget', TimesheetEntryTableWidget);